Librarian.Modules.FeaturedContent = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["startScroll", "stopScroll", "updateNavButtons", "onRelatedContentLoaded", "renderFlags"],

    options: {
        classPrefix: "modules-featuredcontent-",
        orderBy: null,
        order: "desc",
        catPath: null,
        catType: Librarian.catType.file,
        mode: "category", // "files", "recent", "toprated", or "popular"
        catId: -1,
        rootCat: 0,
        recursive: false, // Get files recursively from catPath for category mode
        showView: true,
        doNav: true,
        autoNavTime: 0, // Timer in ms
        categories: false,
        slides: false, // Only used by "popular"
        subHeader: false, // Add sub to tiles in the tile list
        navImages: true,
        navImageType: null,
        numberOfFiles: 20, // Number of files to show
        params: null, // Additional parameters
        useGetSendData: true,
        eventGroupOptions: {
            eventGroupType: Librarian.eventGroupType.campaign
        },
        relatedContentOptions: {
            fileId: -1,
            top: 20
        },
        contentType: Librarian.contentType.file,
        contentFilter: null,
        customSendData: null
    },

    tileListContEl: null,
    prevButtonEl: null,
    prevImg: null,
    nextButton: null,
    nextImg: null,

    homeScrollFx: null,
    homeTileList: null,
    homeScrollInterval: null,

    autoNavInterval: null,

    initialize: function(options, wrapperEl) {
        this.setOptions(options);

        if (!this.options.orderBy) {
            if (this.options.catType == Librarian.catType.globalFavorite)
                this.options.orderBy = "GroupLastModDate";
            else
                this.options.orderBy = "FileDBImportDate";
        }

        this.parent(this.options, wrapperEl);
    },

    reload: function() {
        // Make sure we don't destroy the wrapper,
        // but save the set value so we can reset it after
        var destroyWrapperVal = this.destroyWrapper;
        this.destroyWrapper = false;

        this.destroy();
        this.load();

        // Reset the saved value
        this.destroyWrapper = destroyWrapperVal;
    },

    destroy: function() {
        this.parent();

        var elements = [this.tileListContEl, this.prevButtonEl, this.prevImgEl, this.nextButtonEl, this.nextImgEl];
        for (var i = elements.length; i--;) {
            if (elements[i]) {
                $(elements[i]).destroy();
                elements[i] = null;
            }
        }

        if (this.homeScrollFx) {
            this.homeScrollFx.cancel();
            this.homeScrollFx = null;
        }

        if (this.homeTileList) {
            this.homeTileList.destroy();
            this.homeTileList = null;
        }

        if (this.homeScrollInterval) {
            clearInterval(this.homeScrollInterval);
            this.homeScrollInterval = null;
        }

        if (this.autoNavInterval) {
            clearInterval(this.autoNavInterval);
            this.autoNavInterval = null;
        }
    },

    load: function() {
        if (!this.wrapperEl || ((this.options.mode == "category") && !(this.options.catPath || this.options.catId > 0)))
            return;

        this.parent();

        if (this.request) {
            this.request.cancel();
            this.request = null;
        }

        if (this.options.doNav) {
            this.setupNavButtons();
            window.addEvent("resize", this.updateNavButtons);

            if (this.options.autoNavTime > 0)
                this.startAutoScroll();
        }

        this.tileListContEl = new Element("div", {
            "class": this.options.classPrefix + "tileList"
        }).inject(this.containerEl);

        this.homeTileList = new Librarian.TileList({
            size: '',
            id: this.options.id + "_tileListWrapper",
            wrapperClass: "tile-list-wrapper-home",
            container: this.tileListContEl,
            allowDrag: true,
            isMainPage: false,
            subHeader: this.options.subHeader
        });
        this.homeTileList.catType = this.options.catType;
        this.homeTileList.options.targetList = tileList;

        if (this.options.doNav) {
            this.homeScrollFx = new Fx.Tween(this.options.id + "_tileListWrapper", {
                duration: 240,
                link: "cancel",
                property: "left",
                onComplete: this.updateNavButtons.bind(this)
        });
        }

        if (this.options.mode == "category") {
            // If this is a Global Favorite, use the correct root Cat ID
            if ((this.options.catType == Librarian.catType.globalFavorite) && (this.options.rootCat == 0) && Librarian.specialCategories && Librarian.specialCategories.GlobalFavorites)
                this.options.rootCat = Librarian.specialCategories.GlobalFavorites.CatId;

            var url = null;
            if (this.options.catType == Librarian.catType.event)
                url = Librarian.path.getEventUrl("getegcc");
            else {
                var method = this.options.categories ? "getcc" : this.options.recursive ? "getcfi" : "getfiles";
                if (this.options.catType == Librarian.catType.globalFavorite)
                    method = this.options.categories ? "getcc" : "getgroups";

                url = Librarian.path.getMethodUrl(method);
            }

            url += "&out=dgrid&orderby=" + this.options.orderBy + "&order=" + this.options.order + "&pcid=" + this.options.rootCat + "&cid=" + this.options.catId + "&cpath=" + encodeURIComponent(this.options.catPath);

            if (Librarian.search.viewNameByType) {
                if ((this.options.catType == Librarian.catType.file) && Librarian.search.viewNameByType[Librarian.Search.outputTypes.FILES])
                    url += "&vname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.FILES];
                else if ((this.options.catType == Librarian.catType.globalFavorite) && Librarian.search.viewNameByType[Librarian.Search.outputTypes.GROUPS])
                    url += "&vname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.GROUPS];
            }

            var options = {
                url: url,
                onSuccess: function(json) {
                    if (!json || !json.data || !json.data[0])
                        return;

                    if (this.options.contentFilter && typeOf(this.options.contentFilter) === "function") {
                        json = this.options.contentFilter(json);
                    }

                    this.homeTileList.loadComplete(json);
                    if (this.options.doNav)
                        this.updateNavButtons();

                    if (this.options.showView) {
                        var catId = json.data[0].catid || 0;

                        new Element("a", {
                                "class": (this.options.classPrefix || '') + "view right",
                                "html": Librarian.Lang.getString("modules_featured_view"),
                                "href": "#catid=" + catId + "&type=" + this.options.catType
                            }).injectInside(this.headerEl)
                            .addOnClick(function() {
                                // Call this explicitly, if not the first time clicking the 'View All' button does nothing.
                                Librarian.Utils.onHashChange(Librarian.Utils.getHash(), true);
                            });
                    }
                }.bind(this),
                onFailure: Librarian.Utils.onFailure
            };

            this.request = new Librarian.Request.JSON(this.getRequestOptions(options));
            this.request.send();
        }
        else {
            var onDataLoaded = function(json) {
                if (!json || !json.data || !json.data[0])
                    return;

                // Make sure files with fake slides have the correct fake slide count
                for (var i = json.data.length; i--;) {
                    if (this.options.mode == "relatedContent") {
                        var hasExpired = false,
                            hasViewOnly = false;
                        json.data[i].ignoreFilter = true;
                        var flagClasses = Librarian.Utils.getFlaggingClasses(json.data[i]);
                        for (var j = 0, len = flagClasses.length; j < len; j++) {
                            var tooltip = null;
                               
                            if (flagClasses[j].contains("expired-flag")) {
                                hasExpired = true;
                                tooltip = Librarian.Lang.getString("expired_content");
                            }
                            if (flagClasses[j].contains("viewonly-flag")) {
                                hasViewOnly = true;
                                tooltip = Librarian.Lang.getString("viewonly_content");
                            }
                            self.fileInfo[i] = {
                                expired: flagClasses[i],
                                tooltip: tooltip
                            };
                        }
                    }
                    var ext = Librarian.Utils.getExtensionFromData(json.data[i], true);
                    if ((json.data[i].pagecount == 0) && Librarian.extensions.hasFakeSlides(ext))
                        json.data[i].pagecount = 1;
                }

                this.homeTileList.loadComplete(json);

                if (this.options.doNav)
                    this.updateNavButtons();
            }.bind(this);

            if (this.options.contentType == Librarian.contentType.eventGroup) {
                var eventOptions = Object.merge({}, { maxRows: this.options.numberOfFiles}, this.options.eventGroupOptions);
                if (this.options.mode == "recent")
                    this.request = Librarian.Utils.getNewestEventGroups(eventOptions, true, onDataLoaded);
                else if (this.options.mode == "popular")
                    this.request = Librarian.Utils.getPopularEventGroups(eventOptions, true, onDataLoaded);
            }
            else {
                if (this.options.mode == "files")
                    this.request = Librarian.Utils.getFilesByMethod(this.options.numberOfFiles, onDataLoaded, null, "getfilelist", Librarian.Search.outputTypes.FILES, null, this.options.params, this.options.useGetSendData, this.options.customSendData);
                if (this.options.mode == "recent")
                    this.request = Librarian.Utils[this.options.catType == Librarian.catType.file ? "getNewestFiles" : "getNewestGroups"](this.options.numberOfFiles, onDataLoaded, null, null, null, this.options.useGetSendData, this.options.customSendData);
                else if (this.options.mode == "toprated")
                    this.request = Librarian.Utils.getTopRated(this.options.numberOfFiles, this.options.catType, onDataLoaded, this.options.useGetSendData, this.options.customSendData);
                else if (this.options.mode == "popular")
                    this.request = Librarian.Utils.getPopular(this.options.numberOfFiles, Librarian.Utils.getContentTypeFromCategoryType(this.options.catType, this.options.slides), onDataLoaded, null, null, this.options.useGetSendData, this.options.customSendData);
                else if (this.options.mode == "created") {
                    var url = Librarian.path.getMethodUrl("getfiles") + "&out=dgrid&orderBy=fFileLastModDate&order=DESC&perpage=" + this.options.numberOfFiles + "&cid=" + Librarian.specialCategories.UserApproved;

                    this.request = new Librarian.Request.JSON(this.getRequestOptions({
                        url: url,
                        onSuccess: onDataLoaded
                    }));
                    this.request.send();
                }
                else if (this.options.mode == "relatedContent") {
                    var self = this;
                    self.fileInfo = [];
                    var url = Librarian.path.getMethodUrl("getsmlrf");
                    url += "&max=" + this.options.relatedContentOptions.top;
                    url += "&fid=" + this.options.relatedContentOptions.fileId;
                    url += "&out=dgrid";
                    url += "&vname=" + Librarian.search.viewNameByType[Librarian.Search.outputTypes.FILES];

                    this.request = new Librarian.Request.JSON(this.getRequestOptions({
                        url: url,
                        onSuccess: function(json) {
                            onDataLoaded(json);
                            self.onRelatedContentLoaded();
                        }
                    }));
                    this.request.send();
                }
            }
        }
    },

    onRelatedContentLoaded: function() {
        var tiles = this.homeTileList.wrapper.getElements(".tile-list-items-wrapper");
        var maxShown = 5;
        var self = this;

        for (var i = 0, len = tiles.length; i < len; i++) {
            tiles[i].flags = new Element("div", { "class": "tile-list-flags-wrapper " + Librarian.Utils.getFlaggingLocation(Librarian.flagging.location) }).injectInside(tiles[i]);
            if (Librarian.flagging.enabled && Librarian.flagging.showOnTileList)
                this.renderFlags(tiles[i]);
        }

        for (var i = maxShown, len = tiles.length; i < len; i++) {
            if (i % maxShown === 0) {
                var showMoreEl = new Element("div", {
                    "class": "tile-list-items-wrapper tile-list-show-more",
                });
                var showMoreElText = new Element("span", {
                    "class": "tile-list-item-image-cont tile-list-show-more-text",
                    "text": "See More"
                });

                showMoreEl.grab(showMoreElText);
                showMoreEl.addEvent("click", function(el) {
                    var siblings = this.getAllNext(":not(.tile-list-show-more)");
                    var siblingCount = Math.min(maxShown, siblings.length);
                    for (var j = 0, len = siblingCount; j < len; j++) {
                        siblings[j].show();
                    }

                    var nextShowMore = this.getNext(".tile-list-show-more");
                    if (nextShowMore) {
                        nextShowMore.setStyle("display", "inline-block");
                    }

                    this.destroy();

                    if (self.options.doNav)
                        self.updateNavButtons();

                });
                tiles[i].grab(showMoreEl, "before");
            }

            tiles[i].hide();
        }

        if (this.options.doNav)
            this.updateNavButtons();
    },

    renderFlags: function(tile) {
        if (tile.flags)
            tile.flags.empty();

        var flagClasses = Librarian.Utils.getFlaggingClasses(this.data);
        for (var i = 0, len = flagClasses.length; i < len; i++) {
            var tooltip = null;
            new Element("div", {
                "class": flagClasses[i] + " content-flag",
                "title": tooltip
            }).injectInside(tile.flags);
        }
    },

    getRequestOptions: function(options) {
        // If we have a custom data function
        if (this.options.useGetSendData && ((typeof Library.getSendData == "function") || (typeof this.options.customSendData == "function"))) {
            // Get the data to send and check that it is valid
            var data = { cattype: this.options.catType };
            if ((typeof this.options.customSendData == "function")) {
                data = this.options.customSendData(data, options.url);
            } else {
                data = Library.getSendData(data, options.url);
            }

            if (data) {
                // If the given data is an object, stringify it
                if (typeof data.data == "object")
                    data.data = JSON.stringify(data.data);
                // Convert the data to Base64
                if (typeof Base64 != "undefined")
                    data.data = Base64.encode(data.data);

                // And save it
                options.data = data.data;
                options.method = "post";
                options.url = data.url;
            }
        }

        return options;
    },

    setupNavButtons: function() {
        this.prevButtonEl = new Element("a", {
            "class": (this.options.classPrefix || '') + "navButton left"
        }).inject(this.containerEl);
        if (this.options.navImages) {
            this.prevImgEl = new Element("img").inject(this.prevButtonEl);
            // TODO: Use style
            this.prevImgEl.src = Librarian.path.getLibraryPath() + "img/previousLg." + (this.options.navImageType || "gif");
        }

        this.prevButtonEl.addEvent("mousedown", this.startScroll.pass(false));
        this.prevButtonEl.addEvent("mouseup", this.stopScroll);
        this.prevButtonEl.addEvent("mouseout", this.stopScroll);

        this.nextButtonEl = new Element("a", {
            "class": (this.options.classPrefix || '') + "navButton right"
        }).inject(this.containerEl);
        if (this.options.navImages) {
            this.nextImgEl = new Element("img").inject(this.nextButtonEl);
            // TODO: Use style
            this.nextImgEl.src = Librarian.path.getLibraryPath() + "img/nextLg." + (this.options.navImageType || "gif");
        }

        this.nextButtonEl.addEvent("mousedown", this.startScroll.pass(true));
        this.nextButtonEl.addEvent("mouseup", this.stopScroll);
        this.nextButtonEl.addEvent("mouseout", this.stopScroll);
    },

    // Start scrolling when button is clicked
    startScroll: function(right) {
        clearInterval(this.homeScrollInterval);
        this.doScroll(right);

        // Keep scrolling while button is held
        this.homeScrollInterval = setInterval(function () {
            this.doScroll(right);
        }.bind(this), 250);

        // Stop auto-scrolling when clicking
        clearInterval(this.autoNavInterval);
        this.autoNavInterval = null;
    },

    // Stop scrolling after releasing button
    stopScroll: function() {
        clearInterval(this.homeScrollInterval);
        this.updateNavButtons();

        // Resume auto-scrolling
        if (this.options.autoNavTime > 0)
            this.startAutoScroll();
    },

    // Set timer to auto scroll on loop
    startAutoScroll: function() {
        // Don't start multiple timers
        if (this.autoNavInterval)
            return;

        this.autoNavInterval = setInterval(function() {
            this.doScroll(true, true);
        }.bind(this), this.options.autoNavTime);
    },

    doScroll: function(rightButton, loop) {
        if (!this.homeTileList)
            return;

        var tileListEl = $(this.homeTileList.wrapper);
        if (tileListEl && this.homeScrollFx) {
            var left = tileListEl.getStyle("left").toInt(),
                // Scroll the width of 1 tile
                scroll = this.getTileWidth(tileListEl),
                width = tileListEl.getBoundingClientRect().width,
                parentWidth = tileListEl.getParent().getBoundingClientRect().width,
                leftBoundary = 0,
                // Determine how much larger this container is than its parent
                // This number (expressed as negative) is the amount that the container can be moved to the left
                rightBoundary = (width > parentWidth) ? (parentWidth - width) : 0,
                boundary = leftBoundary,
                boundaryFn = Math.min;

            if (rightButton) {
                // Move container to the left
                scroll = -scroll;
                boundaryFn = Math.max;
                boundary = rightBoundary;
            }

            if (loop && left == boundary) {
                // Loop back around if we are at the edge
                left = rightButton ? 0 : rightBoundary;
            }
            else {
                // Ensure that the container does not scroll past its boundary
                left = boundaryFn(left + scroll, boundary);
            }

            this.homeScrollFx.start(left);
        }
    },

    getTileWidth: function (tileListEl) {
        var width = 220;

        var tiles = tileListEl.getChildren();
        if (tiles && tiles[0]) {
            var tile = tiles[0];
            width = tile.getBoundingClientRect().width;

            // Include these properties widths when calculating the scroll size to be more accurate
            var properties = ["margin", "padding", "border*Width"],
                directions = ["Left", "Right"];
            for (var i = properties.length; i--;) {
                for (var j = directions.length; j--;) {
                    var styleName = properties[i];
                    if (styleName.contains('*'))
                        styleName = styleName.replace('*', directions[i]);
                    else
                        styleName += directions[i];

                    var styleVal = (tile.getStyle(styleName) || '0').toInt();
                    if (styleVal > 0)
                        width += styleVal;
                }
            }
        }

        return width;
    },

    updateNavButtons: function() {
        if (!this.homeTileList)
            return;

        var tileListEl = $(this.homeTileList.wrapper);
        if (tileListEl) {
            // Previous button
            var left = tileListEl.getStyle("left").toInt(),
                itemEl = this.prevImgEl,
                buttonEl = this.prevButtonEl,
                disabled = (left >= 0);

            if (itemEl && buttonEl) {
                Librarian.Utils.setButtonState(itemEl, buttonEl, disabled);
            }
            else if (buttonEl)
                buttonEl.toggleClass("disabled", disabled);
            

            // Next button
            itemEl = this.nextImgEl;
            buttonEl = this.nextButtonEl;
            var right = left + tileListEl.getBoundingClientRect().width -1,
                parentRight = tileListEl.getParent().getWidth();

            disabled = (parentRight >= right);
            if (itemEl && buttonEl) 
                Librarian.Utils.setButtonState(itemEl, buttonEl, disabled);   
            else if (buttonEl)
                buttonEl.toggleClass("disabled", disabled);
        }
    }
});